import { INSURANCE_CONTENT_TYPES } from './runnerApiClient';

export interface InsuranceForm {
  insurer: string;
  policyNumber: string;
  expiresOn: string;
  file: File | null;
}

/** An i18n key under `insurance.` when the form cannot be sent, else null. */
export function insuranceFormError(form: InsuranceForm, todayYmd: string): string | null {
  if (!form.insurer.trim() || !form.policyNumber.trim() || !/^\d{4}-\d{2}-\d{2}$/.test(form.expiresOn) || !form.file) {
    return 'missingFields';
  }
  if (!(INSURANCE_CONTENT_TYPES as readonly string[]).includes(form.file.type)) return 'badType';
  if (form.expiresOn < todayYmd) return 'alreadyExpired';
  return null;
}

/** Today in the browser's own calendar, as YYYY-MM-DD. */
export function localTodayYmd(now: Date = new Date()): string {
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${m}-${d}`;
}

/** A card date is a calendar day, not an instant — never let a timezone move it. */
export function formatCardDate(ymd: string, language: string): string {
  const [y, m, d] = ymd.split('-').map(Number);
  if (!y || !m || !d) return ymd;
  return new Date(y, m - 1, d).toLocaleDateString(language.startsWith('es') ? 'es-US' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}
